/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    ICheckoutCustomerAccountPaymentViewProps,
    IAccountPaymentEditViewForm,
    IAccountPaymentSummaryViewForm
} from '@msdyn365-commerce-modules/checkout';
import { ICheckoutCustomerAccountPaymentProps as ICheckoutCustomerAccountPaymentExtensionProps } from '../definition-extensions/checkout-customer-account-payment.ext.props.autogenerated';
import { PaymentContext, IPaymentTenderType } from '../../../modules/payment-container/context/payment-context';
// import { CustomerBalances } from '@msdyn365-commerce/retail-proxy';
import MsDyn365 from '@msdyn365-commerce/core';

export const SummaryForm: React.FC<IAccountPaymentSummaryViewForm> = ({
    formProps,
    label,
    paymentAmount,
    addPaymentButton,
    appliedLine,
    bottomBorder
}) => (
    <Node {...formProps}>
        <>
            {label}
            {appliedLine}
            {bottomBorder}
        </>
    </Node>
);

export const EditForm: React.FC<IAccountPaymentEditViewForm> = (
    {
        formProps,
        inputLabel,
        inputAmount,
        customerName,
        customerAccountNumber,
        addPaymentButton,
        customerSince,
        accountCredit,
        alert,
        accountDetails,
        appliedLine,
        bottomBorder
    },
    props
) => {
    return (
        <Node {...formProps}>
            <>
                {customerName}
                {customerAccountNumber}
                {customerSince}
                {/* {accountCredit} */}
                {/* {accountDetails} */}
                {/* {inputLabel} */}
                {getInputLabel()}
                {/* {alert} */}
                {appliedLine}
                {bottomBorder}
            </>
        </Node>
    );
};

let customInputLabel = '';

const getInputLabel = () => {
    return (
        <span id='ms-checkout-customer-account__label' className='ms-checkout-customer-account__input-label'>
            {customInputLabel}
        </span>
    );
};

// const getAvailableCredit = (creditBalances: CustomerBalances | undefined) => {
//     let availableCredit = 0;

//     if (!creditBalances) {
//         return 0;
//     }

//     if (creditBalances.InvoiceAccountCreditLimit === 0) {
//         availableCredit = creditBalances.CreditLimit - creditBalances.Balance - creditBalances.PendingBalance;
//     } else {
//         availableCredit = creditBalances.InvoiceAccountCreditLimit - creditBalances.InvoiceAccountBalance - creditBalances.InvoiceAccountPendingBalance;
//     }

//     return availableCredit;
// };

const addPayment = async (props: ICheckoutCustomerAccountPaymentViewProps): Promise<void> => {
    const checkoutState = props.data.checkout.result;

    if (!checkoutState) {
        props.context.telemetry.error('checkout state not found');
        return;
    }

    // const availableCredit = getAvailableCredit(props.data.creditBalances?.result);
    const cartTotal = (await props.data.checkout).checkoutCart.cart.TotalAmount;

    // console.log(availableCredit);
    // console.log(cartTotal);
    // if (cartTotal && availableCredit >= cartTotal) {
    if (cartTotal) {
        await checkoutState.updateCustomerAccountAmount({ newAmount: cartTotal });
        props.context.telemetry.information('customer account payment amount updated');
    }
};

const CheckoutCustomerAccountView: React.FC<ICheckoutCustomerAccountPaymentViewProps &
    ICheckoutCustomerAccountPaymentExtensionProps<{}>> = props => {
    const {
        checkoutCustomerAccount,
        summaryView,
        editView,
        moduleState,
        id,
        config: { tenderType }
    } = props;

    const paymentContext = React.useContext(PaymentContext);
    const paymentTenderTypes: IPaymentTenderType[] = [];
    // console.log(props);

    React.useEffect(() => {
        tenderType?.map(tt => {
            paymentTenderTypes.push({
                tenderTypeId: tt.tenderId,
                tenderName: tt.tenderName,
                showOnNormalPartsCheckout: tt.showOnNormalPartsCheckout ?? true,
                showOnInvoiceCheckout: tt.showOnInvoiceCheckout ?? true
            });
        });
        paymentContext.registerPaymentMethod(id, paymentTenderTypes);
        sessionStorage.removeItem('ON_ACCOUNT_APPLIED');
        customInputLabel = props.config.processedOnAccountText || '';
    }, []);

    if (MsDyn365.isBrowser) {
        document.querySelector('.payment-selector__button-container--on-account')?.addEventListener('click', () => {
            if (sessionStorage.getItem('ON_ACCOUNT_APPLIED') === '1') {
                return;
            }
            sessionStorage.setItem('ON_ACCOUNT_APPLIED', '1');
            addPayment(props);
        });
    }

    return (
        <Module {...checkoutCustomerAccount}>
            {moduleState.isReady && summaryView && <SummaryForm {...summaryView} />}
            {!moduleState.isReady && editView && <EditForm {...editView} />}
        </Module>
    );
};

export default CheckoutCustomerAccountView;
